import _ from 'underscore';
import React, { memo } from 'react';
import cx from 'classnames';

import Icon from 'components/Icon';
import Thumbnail from 'components/Thumbnail';

import { MaterialPropType } from 'propTypes/common';

import { imagePrefix } from 'utils/helpers/images';
import styles from '../styles.module.scss';

const Video = memo(({ material }) => {
	const getRandomImage = () =>
		`${imagePrefix}images/institutes/videoPreviews/${_.random(1, 10)}.jpg`;

	const file = !_(material.files).isEmpty()
		? material.files[0]
		: getRandomImage();

	const { width = 645, height = 364 } = file;

	return (
		<div
			className={styles.item}
			style={{ width: `${(23 * width) / height}em` }}
		>
			<Thumbnail
				file={file}
				className={styles.image}
				params={{
					height: 364
				}}
			/>
			<div className={styles.iconWrapper}>
				<Icon className={cx(styles.icon, styles.video)} icon="video" />
			</div>
		</div>
	);
});

Video.propTypes = {
	material: MaterialPropType.isRequired
};

export default Video;
